module.exports = __webpack_public_path__ + "public/images/icons/uae.227853898636373201b3f05c91da8bf3.png";